export function registerServiceWorker() {

    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker
        .register(`${process.env.PUBLIC_URL}/service-worker.js`)
        .then(registration => {
            console.log('[SW] Registrado con éxito.');

            // 1️⃣ Detectar cuando haya una nueva versión instalada y pending
            registration.onupdatefound = () => {
                
                const newWorker = registration.installing;
                
                if (!newWorker) return;

                newWorker.onstatechange = () => {
                    if (
                        newWorker.state === 'installed' &&
                        navigator.serviceWorker.controller
                    ) {
                        console.log('[SW] Nueva versión disponible');
                        // Dispara el evento global para notificar al index.js
                        const event = new CustomEvent('swUpdated', { detail: registration });
                        window.dispatchEvent(event);
                    }
                };

            };

            // 2️⃣ Forzar un check de actualización justo al cargar la app
            registration.update().catch(err =>
                console.error('[SW] Error forzando update():', err)
            );

            // 3️⃣ Volver a chequear cuando la página recupere el foco
            window.addEventListener('focus', () => {
                console.log('[SW] Página con foco, forzando update()');
                registration.update();
            });

            // 4️⃣ Chequeo periódico (cada 30 min)
            setInterval(() => {
                console.log('[SW] Check periódico de actualización');
                registration.update();
            }, 1000 * 60 * 30);
        }).catch(err => console.error('[SW] Error de registro:', err));

    // 5️⃣ Cuando el SW haga skipWaiting() y tome control, recarga la página
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        console.log('[SW] Controller cambió, recargando página…');
        window.location.reload();
    });

    // 6️⃣ Escucha FORCE_RELOAD enviado desde el SW si navigate() falla
    navigator.serviceWorker.addEventListener('message', event => {
        if (event.data === 'FORCE_RELOAD') {
            console.log('[Cliente] FORCE_RELOAD recibido, recargando…');
            window.location.reload();
        }
    });

}
